<template>
  <div
    class="d-flex align-items-center gap-3 rounded-4 p-3 px-4 mb-4"
    :style="headerStyle"
  >
    <div
      class="d-flex align-items-center justify-content-center rounded-3"
      style="width: 56px; height: 56px; background: rgba(255,255,255,0.2); min-width: 56px;"
    >
      <i
        :class="icon"
        class="text-white"
        style="font-size: 1.75rem;"
      />
    </div>
    <div>
      <h2
        class="text-white fw-bold mb-0"
        style="font-size: 1.5rem;"
      >
        {{ title }}
      </h2>
      <p
        class="mb-0"
        style="color: rgba(255,255,255,0.8); font-size: 0.95rem;"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminPageHeader',

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'fas fa-cog'
    },
    category: {
      type: String,
      default: '',
      validator: v => ['', 'management', 'operations', 'configuration', 'configurations'].includes(v)
    },
    gradient: {
      type: String,
      default: 'green',
      validator: v => ['green', 'amber', 'blue', 'red', 'yellow', 'orange'].includes(v)
    }
  },

  computed: {
    resolvedGradient () {
      const categoryMap = {
        management: 'blue',
        operations: 'amber',
        configuration: 'green',
        configurations: 'green'
      }

      const routeMap = {
        'admin.users': 'blue',
        'admin.students': 'blue',
        'admin.student-residences': 'blue',
        'admin.violations': 'blue',

        'admin.appointments': 'amber',
        'admin.lost-and-found': 'amber',
        'admin.complaints': 'amber',
        'admin.feedback': 'amber',

        'admin.violation-types': 'green',
        'admin.appointment-slots': 'green',
        'admin.appointment-concern-types': 'green',
        'admin.lf-item-categories': 'green',
        'admin.resource-categories': 'green',
        'admin.resources': 'green',
        'admin.announcements': 'green',
        'admin.events': 'green',
        'admin.lf-item-claims': 'green'
      }

      const normalizedCategory = (this.category || '').toLowerCase().trim()
      if (categoryMap[normalizedCategory]) {
        return categoryMap[normalizedCategory]
      }

      const routeName = this.$route?.name
      if (routeName && routeMap[routeName]) {
        return routeMap[routeName]
      }

      if (this.gradient === 'yellow' || this.gradient === 'orange') {
        return 'amber'
      }

      return this.gradient
    },

    headerStyle () {
      const gradients = {
        green: 'linear-gradient(135deg, #10b981, #059669)',
        amber: 'linear-gradient(135deg, #f59e0b, #d97706)',
        blue: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
        red: 'linear-gradient(135deg, #ef4444, #dc2626)'
      }
      const shadows = {
        green: 'rgba(16,185,129,0.3)',
        amber: 'rgba(245,158,11,0.3)',
        blue: 'rgba(59,130,246,0.3)',
        red: 'rgba(239,68,68,0.3)'
      }
      return {
        background: gradients[this.resolvedGradient],
        boxShadow: `0 10px 30px ${shadows[this.resolvedGradient]}`
      }
    }
  }
}
</script>
